import { restClient } from '@/Core'

import { toNode } from '../Helpers/diskResponse'

import type { DiskNode } from '../Contracts/DiskNode'

/** Перейменувати: `PATCH /services/disk/nodes/{uuid}` з `{name}`. */
export const RenameDiskNodeTask = async (uuid: string, name: string): Promise<DiskNode> => {
    const response = (await restClient.patch(`/services/disk/nodes/${encodeURIComponent(uuid)}`, {
        json: { name },
    })) as unknown

    return toNode(response)
}
